import { BaseTypeSchema } from "../BaseTypeSchema";
import { BaseNumberSchema } from "./BaseNumberSchema";
import { VariableType } from "../VariableType";

export class ArraySchema extends BaseTypeSchema
{
    static REGEX_COMMA_SEPARATED_INTEGERS: RegExp = /^(\d+(,\d+)*)?$/;
    static REGEX_COMMA_SEPARATED_FLOATS: RegExp = /^(\d+(.\d+)?(,\d+(.\d+)?)*)?$/;
    static REGEX_COMMA_SEPARATED_STRINGS: RegExp = /^([\w\d]+(,[\w\d]+)*)?$/;
    items: BaseTypeSchema[];
    min: number | null;
    max: number | null;
    constructor(required: boolean, items: BaseTypeSchema[] = [], min: number | null = null, max: number | null = null)
    {
        super(VariableType.Array, required);
        if (items == null)
            items = [];
        this.items = items;
        this.min = min;
        this.max = max;
    }
    setItem(items: BaseTypeSchema[]): ArraySchema
    {
        this.items = items;
        return this;
    }
    addItem(item: BaseTypeSchema): ArraySchema
    {
        this.items.push(item);
        return this;
    }
    setMin(min: number | null): BaseNumberSchema
    {
        this.min = min;
        return this;
    }
    setMax(max: number | null): BaseNumberSchema
    {
        this.max = max;
        return this;
    }
    override check(): void
    {
        this.items.forEach(i => i.check());
    }
}